// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"9ce95d37","120":"8e0ac860","237":"10b7e4b0","301":"ff035221","397":"e7d95344","472":"c95d42a3","532":"2a03f0d1","633":"61e2b7dc","647":"956d6e40"}[chunkId] + ".chunk.js";
};